import React from 'react';
import AllEmailSchedulerContainer from '../../../Containers/AdminContainer/AllEmailScheduler';

const AllEmailSchedulerScreen = () => {
  return (
    <div>
      <AllEmailSchedulerContainer />
    </div>
  );
};

export default AllEmailSchedulerScreen;
